import { z } from "zod";

/**
 * Shared password-creation policy for the portal. Applied wherever a customer
 * sets a new password - accept invite, reset password, change password - on
 * both the client (inline form validation) and the server (the authoritative
 * check). Login is intentionally exempt: it only bounds length so pre-existing
 * passwords keep authenticating.
 */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 200;

/** One-line summary of the policy, shown as helper text under password fields. */
export const PASSWORD_POLICY_HINT = `At least ${PASSWORD_MIN_LENGTH} characters, including a letter and a number or symbol.`;

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, `Use at least ${PASSWORD_MIN_LENGTH} characters`)
  .max(PASSWORD_MAX_LENGTH, `Use at most ${PASSWORD_MAX_LENGTH} characters`)
  .refine((v) => /[A-Za-z]/.test(v), { message: "Include at least one letter" })
  .refine((v) => /[0-9]/.test(v) || /[^A-Za-z0-9]/.test(v), {
    message: "Include at least one number or symbol",
  });
